import React from 'react';
import {Link} from 'react-router-dom';
import {Context} from '../context';
import LabelAndInput from './UI/LabelAndInput';
import Button from './UI/Button';
import Section from './UI/Section';
import ErrorNote from './UI/ErrorNote';
import {useNavigate} from 'react-router-dom';
import {scope} from '../settings';

export default function SignIn() {
  const {localeText, loginUser, loading} = React.useContext(Context);

  const [errors, setErrors] = React.useState([]);
  const [username, setUserName] = React.useState('');
  const [password, setPassword] = React.useState('');
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();

    loginUser({
      username,
      password
    }).then(ret => {
      if (ret.errors) {
        setErrors(() => ret.errors.map(err => err.error.slug));
        return;
      }
      navigate('/loadfunds');
    });
  };

  return (
    <Section heading={localeText('rw_signin_header_sign_in', 'Sign In')}>
      <form className='flex flex-col' name='LoginForm' onSubmit={handleSubmit}>
        <p>
          {localeText(
            'rw_signin_msg_login',
            'Sign in to manage your account, register your Transit Card, purchase pass products and add value to your account.'
          )}
        </p>
        <div>
          <LabelAndInput
            inputId='login-email'
            type='email'
            required
            label={localeText('rw_signin_title_email', 'Email')}
            name='email'
            placeholder={localeText(
              'rw_signin_placeholder_email',
              'user@domain.com'
            )}
            defaultValue={username}
            onChange={e => setUserName(e.target.value)}
          />
          <LabelAndInput
            inputId='login-password'
            type='password'
            required
            label={localeText('rw_signin_title_password', 'Password')}
            name='password'
            placeholder={localeText(
              'rw_signin_placeholder_password',
              'Password'
            )}
            defaultValue={password}
            onChange={e => setPassword(e.target.value)}
          />
        </div>
        {errors &&
          errors.map((err, index) => (
            <ErrorNote key={index}>
              {localeText(
                err === 'serr_denied-access-locked'
                  ? 'rw_msg_account_locked'
                  : err
              )}
            </ErrorNote>
          ))}
        <div className='flex gap-2'>
          <Link
            className='w-1/2'
            to='/register'
            style={{textDecoration: 'none'}}
            click='switchRegister()'
          >
            <Button
              buttonId='create-account'
              type='button'
              className='w-full'
              loading={loading}
              style={{whiteSpace: 'normal'}}
            >
              {localeText('rw_signin_button_create_acc', 'Create Account')}
            </Button>
          </Link>

          <Button
            buttonId='sign-in'
            type='submit'
            className={`w-1/2 ${username.trim() !== '' ? '' : 'bg-primary'}`}
            loading={loading}
          >
            {localeText('rw_signin_button_sign_in', 'Sign In')}
          </Button>
        </div>
        <p className='self-end'>
          <Link to='/forgot'>
            {localeText('rw_signin_link_reset_password', 'Reset Password')}
          </Link>
        </p>
      </form>
    </Section>
  );
}
